import { useEffect, useRef } from 'react'

export default function ProcessMath ({ children }) {
  const rootElementRef = useRef(null)

  useEffect(() => {
    const rootEl = rootElementRef.current

    // Reset equation numbers.
    // @ts-ignore
    if (window?.MathJax?.texReset) {
      window.MathJax?.texReset()
    }

    // Run MathJax typsetting on just this element
    // @ts-ignore
    if (window?.MathJax?.typeset) {
      window.MathJax?.typeset([rootEl])
    }
  })

  return (
    <span ref={rootElementRef}>
      {children}
    </span>
  )
}
